module.exports = __webpack_public_path__ + "img/primary_4x1.47dac4e9.svg";